import React from "react";
import StudentAccordians from "./StudentAccordians";
import ProjectAccordion from "./ProjectAccordians";

function BatchDetail() {
  const studentInfoArray = [
    {
      name: "Umaima Nadeem",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      contact: "+92-3000000000",
      degree: "Bs Software Engineering",
      project: "green color",
    },
    {
      name: "Farah Mustafa",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "Mahnoor",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "Laiba",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "SAIMA",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "Hassan Abbas",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "Usama Adnan",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "UAsama Shafique",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "Mazhar",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "Kashisf",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "Izhar",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "Ahsan",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "jAWERIA",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "Elsa",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
    {
      name: "Kainat",
      id: "BC190402885",
      email: "Bc190402885@vu.edu.pk",
      "contact ": "+92-3292929292",
      degree: "Bs Software Engineering",
      project: "Synopsis & Thesis managment system (STMS) ",
    },
  ];
  const projectArray = [
    {
      projectName: "Synopsis & Thesis managment system (STMS)",
      member: "3",
      tool1: "React js",
      tool2: "Laravel Php",
      tool3: "Nest Js",
    },
    {
      projectName: "Attendence and parking automation system ",
      member: "3",
      tool1: "React js",
      tool2: "Laravel Php",
      tool3: "Nest Js",
    },
    {
      projectName: "Chatbot in pyhton",
      member: "3",
      tool1: "React js",
      tool2: "Laravel Php",
      tool3: "Nest Js",
    },
  ];
  return (
    <>
      <div className="container batch pb-3">
        <h1 className="text-white btc pb-2">Batch Details</h1>
        <div className="row justify-content-around">
          <div className="col-5 stinfo p-1 mt-3" data-bs-parent="#accordion">
            <h3 className="m-4 head">Students Information</h3>
            <StudentAccordians studentInfoArray={studentInfoArray} />
          </div>
          <div className="col-5 prinfo p-1 mt-3" data-bs-parent="#accordion2">
            <h3 className="m-4 head p-0">Project Information</h3>
            <ProjectAccordion projectArray={projectArray} />
            <div className="card " id="accordian2-data"></div>
          </div>
        </div>
      </div>
      <div className="container">

<button id="see-all-button" className="btn btn-primary sabtn m-5"><a href="/"
        className="text-decoration-none text-light fs-6">Back to home page</a></button>

</div>
    </>
  );
}

export default BatchDetail;
